/**
 * A tinted chip (visual contract v2 §8, "Kind chips"): radius 999, padding 4 × 10, 12 / 500, on a
 * named categorical tint's `soft` with `text` (the guaranteed ink on every categorical `soft`;
 * tests/contrast.ts "category chip"). Text, not a control. An envelope's kind takes its tint from
 * `ENVELOPE_KIND_TINT` (`envelopeKindTint.ts`).
 */
import { Box, useTheme } from '@mui/material';
import { PILL_RADIUS, resolveTokens } from '@/theme';
import { tintFor, type TintName } from '@/theme/categorical';

export function TintChip({ tint, label }: { tint: TintName; label: string }) {
  const tokens = resolveTokens(useTheme());
  return (
    <Box
      component="span"
      data-tint-chip={tint}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        maxWidth: '100%',
        p: '4px 10px',
        borderRadius: `${PILL_RADIUS}px`,
        bgcolor: tintFor(tint, tokens).soft,
        color: tokens.text,
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 500,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Box>
  );
}
